import { useTranslation } from '@lb/i18n'

/**
 * The locale to ask the API for content in.
 *
 * ── Two locales, one control, and that is deliberate ──────────────────────
 * `Architecture_And_Plan.md` §6.3 keeps the **interface** language and the
 * **content** locale as separate concerns, and they are: a member reading a
 * French article in an English interface is a legitimate state, and the back
 * office needs to switch authoring locale without switching its own chrome.
 *
 * Separate concerns are not the same as separate controls. A member has one
 * language button, and asking the API in the other language would mean an
 * English interface listing French titles for no reason a member could name.
 * So this derives one from the other, in one place, rather than either
 * hardcoding `'fr'` at twenty-six call sites — which is what it replaces — or
 * putting a second language picker in the product.
 *
 * **The fallback is the server's job, not ours.** A missing translation comes
 * back in the source locale with `meta.fellBack` naming the borrowed fields, so
 * asking for English never means getting less content — only content marked as
 * not-yet-translated. Filtering client-side would be the mistake.
 */
export function useContentLocale(): string {
  const { i18n } = useTranslation()
  return i18n.language
}
